import React from 'react';
import classNames from 'classnames';
import { ConfigProvider, Radio } from 'antd';
import type { RadioGroupProps } from 'antd';

import cn from './styles.module.scss';

/**
 * Design-system token for the page-header tab switcher: inactive (and outline-
 * checked) buttons render with a transparent fill so the control blends onto
 * any header surface. Scoped here via ConfigProvider — deliberately NOT global —
 * so it cannot leak into antd internals that render Radio.Group (e.g. Calendar)
 * or into in-form Radio.Groups that want the default opaque fill.
 */
const NAV_TABS_THEME = {
  components: { Radio: { buttonBg: 'transparent' } },
} as const;

export type NavTabsProps = Omit<RadioGroupProps, 'optionType'>;

/**
 * Outlined, transparent-fill tab switcher used next to page titles
 *
 * A thin wrapper over antd `Radio.Group` that pins `optionType="button"`, scopes
 * the brand transparent-fill token, and keeps the options on a single line
 */
export const NavTabs = React.forwardRef<HTMLDivElement, NavTabsProps>(
  ({ className, ...props }, ref) => (
    <ConfigProvider theme={NAV_TABS_THEME}>
      <Radio.Group
        ref={ref}
        {...props}
        className={classNames(cn.root, className)}
        optionType="button"
      />
    </ConfigProvider>
  ),
);

NavTabs.displayName = 'NavTabs';
